import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateTimeAdapter } from '@danielmoncada/angular-datetime-picker';
import * as moment from 'moment';


@Injectable()
export class TranslationService {
  constructor(
    private translateService: TranslateService,
    private dateTimeAdapter: DateTimeAdapter<any>
  ) { }

  async getTranslation(key: string, params?: { [key: string]: any}) {
    return await this.translateService.get(key, params).toPromise();
  }

  changeAppLanguage(lang: string) {
    this.translateService.use(lang);
    this.dateTimeAdapter.setLocale(lang);
    this.dateTimeAdapter.firstDayOfTheWeek = moment.localeData(lang).firstDayOfWeek();
  }

  changeDefaultAppLanguage(lang: string) {
    this.translateService.setDefaultLang(lang);
  }

  getTranslationSync(key: string) {
    return this.translateService.instant(key);
  }
}
